/**
 * An Add material arrival's session placement (#1393 R17, M4-A3). The course
 * address consumes `unit` when the Resources owner opens the new material's
 * visit (contract 1, rule 7), so the unit travels in navigation state. It is
 * only a starting placement: the editor refuses a session the course lacks.
 */
const MATERIAL_UNIT = "imamMaterialUnit";

/** The state handing on `unit`, or handing on none when it is null. */
export function withMaterialUnit(state: unknown, unit: string | null): Record<string, unknown> {
  const next = { ...(state && typeof state === "object" ? state as Record<string, unknown> : {}) };
  if (unit) next[MATERIAL_UNIT] = unit;
  else delete next[MATERIAL_UNIT];
  return next;
}

export function materialUnitOf(state: unknown): string | undefined {
  const unit = state && typeof state === "object" ? (state as Record<string, unknown>)[MATERIAL_UNIT] : undefined;
  return typeof unit === "string" && unit ? unit : undefined;
}
